export default __webpack_public_path__ + "static/media/019-s.d0124006.svg";